import styles from 'css/src/components/common/ui/DropdownRowSlider.module.scss';

import React from 'react';

import Slider from 'js/src/components/common/ui/Slider';
import { AudioVolume } from 'js/src/libs/consts';

export interface DropdownRowSliderProps {
    volumeValue: number;
    onChange: (value: number) => void;
    testId?: string;
}

const DropdownRowSlider = React.memo(function DropdownRowSlider({
    volumeValue,
    onChange,
    testId,
}: DropdownRowSliderProps) {
    return (
        <div className={`${styles['dropdown-row-slider']} dropdown-item`} data-testid={testId}>
            <Slider
                min={AudioVolume.MIN}
                max={AudioVolume.MAX}
                defaultValue={volumeValue}
                onAfterChange={onChange}
                input={true}
                icon="volume_down"
                iconAfter="volume_up"
            />
        </div>
    );
});

export default DropdownRowSlider;
